import yogaPlace from '@/assets/img/users-cases/yoga-place.webp';
import yogaPlaceHow from '@/assets/img/users-cases/yoga-place-how.webp';
import yogaPlaceResult from '@/assets/img/users-cases/yoga-place-result.webp';

export default {
  slug: 'yoga-place',
  order: 9,
  title: '3D Yoga Studio Tour',
  subtitle: 'Calm 3D visuals and soft walkthrough videos',
  tags: ['yogaplace', 'layoutsforyoga'],

  images: {
    hero: yogaPlace,
    aboutTop: yogaPlaceHow,
    aboutBottom: yogaPlaceResult,
  },

  howText:
    'We prepared yoga place floor plan, 2D and 3D layouts, and interior design for yoga place. Plans consider lighting, ventilation, visitor flow, and minimalist style for peaceful practice.',

  resultText:
    'Clients receive ready visualizations and plans for presentations, marketing, and fast project implementation, ensuring attractive yoga spaces.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
